/* eslint-disable react-hooks/exhaustive-deps */
import { useQueryClient } from "@tanstack/react-query";
import { SocketsContext } from "libs/soket";
import { useContext, useEffect } from "react";

import { SUPPORT_TICKETS_QUERY_KEY } from "../constants/enums";

export const useSupportTicketsRealTime = () => {
  const { supportTicketsAdminSocket } = useContext(SocketsContext);
  const queryClient = useQueryClient();

  useEffect(() => {
    const socket = supportTicketsAdminSocket.socket;
    if (!socket) return;

    // Refetch the list queries rather than hand-patching cache: a created /
    // updated ticket must respect every tab's status group plus the active
    // priority / source filters, which a blind upsert can't honour.
    const refetchLists = () =>
      queryClient.invalidateQueries({
        queryKey: [SUPPORT_TICKETS_QUERY_KEY, "list"],
      });

    // A ticket opened through `?ticketId=` is loaded on its own (it may be on
    // no list page shown): refetch it too when a ticket changes.
    const refetchTicket = () =>
      queryClient.invalidateQueries({
        queryKey: [SUPPORT_TICKETS_QUERY_KEY, "detail"],
      });

    socket.on("support-ticket.created", refetchLists);
    socket.on("support-ticket.updated", refetchLists);
    socket.on("support-ticket.updated", refetchTicket);

    return () => {
      socket.off("support-ticket.created", refetchLists);
      socket.off("support-ticket.updated", refetchLists);
      socket.off("support-ticket.updated", refetchTicket);
    };
  }, [supportTicketsAdminSocket.socket]);
};
